import React from 'react';
import Usuario from '../../components/usuario/Usuario';
import Layout from '../../components/layout/Layout';

const UsuarioPage = () => {
    return ( <Layout children={<Usuario />} /> )
}

export default UsuarioPage